import * as React from 'react'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import { WithStyles, withStyles, Button, CircularProgress, Icon, Theme, createStyles } from '@material-ui/core'
import { compose } from 'redux'


const styles = (t: Theme) => createStyles({
    loadingProgress: {
        position: "absolute",
        top: "50%",
        left: "50%",
        marginTop: "-12px",
        marginLeft: "-12px"
    }
});

interface IProps extends WithI18n,
  WithStyles<typeof styles> {
  dispatch: any;
  loading?: boolean;
  isAfter?: boolean;
  icon: any;
  children: any
  onClick: any;
  variant?: string
}

class BtnIcon extends React.Component<IProps, {}> {

  render() {
    const {loading, isAfter, classes, children, onClick, variant} = this.props
    return (
        <Button color='primary' onClick={onClick} {...variant && {variant: "raised"}}>
            {!loading &&
                <React.Fragment>
                    {!isAfter && this.getIcon()}
                    {children}
                    {isAfter && this.getIcon()}
                </React.Fragment>
            }
            {loading &&
                <CircularProgress
                    size={24}
                    className={classes.loadingProgress}
                />
            }

        </Button>
    )
  }

  getIcon = () => {
    return <Icon style={{
        lineHeight: "14px",
        height: "14px",
        overflow:"visible",
        ...this.props.isAfter && {marginLeft: "8px"},
        ...!this.props.isAfter && {marginRight: "8px"},
    }}>{this.props.icon}</Icon>
  };
}

export default compose(
    withI18n,
    withStyles(styles),
)(BtnIcon)



// WEBPACK FOOTER //
// ./src/shared/BtnIcon/BtnIcon.tsx